var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41675 15.5832V2.83317C1.41675 2.44359 1.55546 2.11008 1.83289 1.83265C2.11032 1.55522 2.44383 1.4165 2.83341 1.4165H14.1667C14.5563 1.4165 14.8898 1.55522 15.1673 1.83265C15.4447 2.11008 15.5834 2.44359 15.5834 2.83317V11.3332C15.5834 11.7228 15.4447 12.0563 15.1673 12.3337C14.8898 12.6111 14.5563 12.7498 14.1667 12.7498H4.25008L1.41675 15.5832ZM3.648 11.3332H14.1667V2.83317H2.83341V12.13L3.648 11.3332Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6H12M5 9H12",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextbox);
export default __webpack_public_path__ + "static/media/textbox.7e5d9df8dbce1a2e92c6bf8f7f2a7a6b.svg";
export { ForwardRef as ReactComponent };